<template>
  <img :src="imgUrl"
       alt="max"
  >
</template>
<script setup>
import imgUrl from "@/assets/img/max.png"
</script>